import { useEffect } from 'react';

// Lightweight Crisp chat loader. Requires REACT_APP_CRISP_WEBSITE_ID in env.
const CrispChat = ({ enabled = false }) => {
  useEffect(() => {
    if (!enabled) return;

    const websiteId = process.env.REACT_APP_CRISP_WEBSITE_ID;
    if (!websiteId) return; // Skip if not configured

    // Avoid double-injecting
    if (window.$crisp) return;

    window.$crisp = [];
    window.CRISP_WEBSITE_ID = websiteId;
    (function () {
      const d = document;
      const s = d.createElement('script');
      s.src = 'https://client.crisp.chat/l.js';
      s.async = 1;
      d.getElementsByTagName('head')[0].appendChild(s);
    })();
  }, [enabled]);

  return null;
};

export default CrispChat;


